import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const updateShopConsent = async (domain: string, newConsentRule: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/consent/${newConsentRule}`,
        method: 'PATCH',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
        isEncrypted: true,
    });
}